import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/common/Dialog';
import PropTypes from 'prop-types';
export function ResumeViewer({ pdfUrl, onClose }) {
    const getGoogleDriveFileId = url => {
        if (!url) return null;
        const match = url.match(/[-\w]{25,}/);
        return match ? match[0] : null;
    };

    return (
        <Dialog open={!!pdfUrl} onOpenChange={onClose}>
            <DialogContent fullscreen={true} className="bg-slate-100 h-[calc(100vh-100px)]">
                <DialogHeader>
                    <DialogTitle>Resume Preview</DialogTitle>
                </DialogHeader>
                <iframe
                    src={`https://drive.google.com/file/d/${getGoogleDriveFileId(pdfUrl)}/preview`}
                    className="w-full h-[600px]"
                    allow="autoplay"
                />
            </DialogContent>
        </Dialog>
    );
}

ResumeViewer.propTypes = {
    pdfUrl: PropTypes.string,
    onClose: PropTypes.func,
};
